import { Gamepad2 } from 'lucide-react';
import { getDemoComponent } from './registry';
import type { DemoChallenge } from './types';

/**
 * Renders a playable preview of a challenge's minigame — a faithful web replica
 * of what participants see in the mobile app, driven by the same config. It's a
 * preview only: nothing is submitted to the server. Challenge types without an
 * interactive game show a friendly fallback.
 */
export function ChallengeDemo({ challenge }: { challenge: DemoChallenge }) {
  const Demo = getDemoComponent(challenge);

  if (!Demo) {
    return (
      <div className="rounded-xl border bg-card p-10 text-center">
        <Gamepad2 className="mx-auto mb-3 h-8 w-8 text-muted-foreground/50" />
        <p className="text-sm font-medium text-foreground">No interactive demo for this type</p>
        <p className="mt-1 text-sm text-muted-foreground">
          Only minigame and puzzle challenges have a playable preview.
        </p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-xl space-y-4">
      <div className="flex items-center gap-2 rounded-lg border border-dashed bg-muted/30 px-3 py-2 text-xs text-muted-foreground">
        <Gamepad2 className="h-3.5 w-3.5 shrink-0" />
        Preview — plays exactly as participants see it in the app. Nothing is submitted.
      </div>
      <div className="rounded-xl border bg-card p-5">
        <Demo challenge={challenge} />
      </div>
    </div>
  );
}
